const TERMINAL_STATUSES = new Set(['Completed', 'Update Failed', 'Requires Support']);

export function isDirectUpdateTerminal(status) {
  return TERMINAL_STATUSES.has(String(status || ''));
}

export function directUpdateStatusCopy(status) {
  switch (status) {
    case 'Approved - Ready for Graph Update':
      return { title: 'Preparing Microsoft 365 update', detail: 'Your direct update was accepted and is waiting for the secure update worker.' };
    case 'Updating Microsoft 365':
      return { title: 'Updating Microsoft 365 photo', detail: 'The employee profile photo is being applied now.' };
    case 'Completed':
      return { title: 'Microsoft 365 photo updated', detail: 'The direct update completed successfully and was recorded in the audit trail.' };
    case 'Update Failed':
      return { title: 'Photo update needs attention', detail: 'Microsoft 365 did not accept the update. Open the request details or contact Support.' };
    case 'Requires Support':
      return { title: 'Photo update needs Support', detail: 'The request was held for support review. No further action was taken automatically.' };
    default:
      return { title: 'Checking update status', detail: 'The request status is being refreshed securely.' };
  }
}
export function directUpdaterAccessState(identity) {
  return identity?.capabilities?.directUpdater ? "allowed" : "denied";
}
